module.exports = __webpack_public_path__ + "7979786f34edf23d37f0682a30c2058b.svg";